import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { saveCustomerJourneyCookie } from "@cinch-labs/customer-journey-cookies";
import { Heading } from "@cinch-labs/design-system";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { TrustpilotReviews, Wrapper } from "@cinch-nx/shared-ui";
import { OurCommitmentCarousel, RecentAndRecommendedVehicles, ShopByShape, USPContainer, WeBuyAnyCar } from "./components";
import { storyblokComponents } from "./data/storyblok-renderer-map";
import styles from "./homepage.module.css";
import homePage from "./locale/index";
export const LandingFeatureHomePage = ({ preview , vehiclesData , trustpilotData , story , showPersonalisedComponents , recentlyViewedListings , similarListings  })=>{
    story = useStoryblokState({
        story,
        enableBridge: preview
    });
    const { ourCommitmentSlides , wbac , trustpilotReviews , seo  } = homePage;
    saveCustomerJourneyCookie();
    const isProd = process.env["STAGE_NAME"] === "production";
    // TODO: uncomment when continue with favouriting on home when A&E is back
    // const showFavouritingTab =
    //   readFromEnv(Env.EnableFavouritingHomePageChanges) === 'true'
    // const { status: userStatus } = useUserStore()
    // const { favourites } = useFavouritesStore()
    // this console.logs are required in the ticket to prove we are getting favourites and user Status.
    // console.log('userStatus', userStatus)
    // console.log('favourites', favourites)
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...story,
                fallbackTitle: seo.title,
                fallbackDescription: seo.description
            }),
            !!story.content.herov2 && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.herov2,
                components: storyblokComponents,
                props: {
                    makes: vehiclesData.makes,
                    totalStock: vehiclesData.totalStock,
                    starRating: trustpilotData.stars,
                    starRatingLabel: trustpilotData.starRatingLabel,
                    numberOfReviews: trustpilotData.total
                }
            }),
            story.content.usp ? /*#__PURE__*/ _jsx(USPContainer, {
                slides: story.content.usp
            }) : null,
            showPersonalisedComponents ? /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        element: "h2",
                        className: styles["heading"],
                        children: "Welcome back"
                    }),
                    /*#__PURE__*/ _jsx(RecentAndRecommendedVehicles, {
                        recentlyViewedListings: recentlyViewedListings ?? [],
                        similarListings: similarListings ?? []
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles["valuePropsCardsContainer"],
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: story.content.personalised[0].valuePropositions,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(StoryblokRenderer, {
                        block: story.content.personalised[0].helpMeChoose,
                        components: storyblokComponents
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(ShopByShape, {
                count: vehiclesData.carTypes
            }),
            !showPersonalisedComponents ? /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.whyCinch,
                components: storyblokComponents
            }) : null,
            /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: story.content.partEx,
                components: storyblokComponents
            }),
            /*#__PURE__*/ _jsx(TrustpilotReviews, {
                title: trustpilotReviews.title,
                starRatingLabel: trustpilotData.starRatingLabel,
                numberOfReviews: trustpilotData.total,
                reviews: trustpilotData.reviews
            }),
            !showPersonalisedComponents ? /*#__PURE__*/ _jsx(OurCommitmentCarousel, {
                ...ourCommitmentSlides
            }) : null,
            /*#__PURE__*/ _jsx(WeBuyAnyCar, {
                ...wbac
            }),
            isProd ? /*#__PURE__*/ _jsx("img", {
                alt: "ZeroFox",
                className: styles["zeroFox"],
                src: "https://d21y75miwcfqoq.cloudfront.net/786a6533"
            }) : null
        ]
    });
};
export default LandingFeatureHomePage;
